import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, spacing } from '#/theme/theme';

export const SalariesExploreAuthPageHolder = styled.div`
  background: white;
  display: flex;
`;

export const SalariesExploreAuthPageBody = styled.div`
  flex: 2;
  padding: 0 ${gutterWidth / 2};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SalariesExploreAuthPageSidebar = styled.aside`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 128px;
  flex: 1;
  max-width: 572px;
  min-height: 100vh;
  background-color: ${colors.backgroundGrey};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const SalariesExploreAuthPageSidebarImageHolder = styled.div`
  padding: ${spacing[60]} ${spacing[24]};
  position: sticky;
  top: 128px;
`;
